// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emp-hdr[data-v-6478d658]{display:flex;flex-direction:column;width:100%;--bg-opacity:1;background-color:#fefeff;background-color:rgba(254,254,255,var(--bg-opacity));box-shadow:0 2px 6px rgba(117,108,107,.3)}@media (max-width:959px){.emp-hdr-main[data-v-6478d658]{height:56px}.emp-hdr-nav[data-v-6478d658]{display:none}}@media (min-width:960px){.emp-hdr[data-v-6478d658]{height:128px}.emp-hdr-main[data-v-6478d658]{flex-grow:1}}", ""]);
// Exports
module.exports = exports;
